export const SELECTED_CUSTOMER_COOKIE_NAME = 'epswebportal.selectedCustomer';